import React, { useMemo } from 'react';
import { ForgeBadge, ForgeButton, ForgeIcon, ForgeTooltip } from '@tylertech/forge-react';
import { FilterBarPendoIds } from './types';
import { I18n } from 'common/i18n';

const scope = 'shared.components.filter_bar';

/**
 * Button component for applying all filters at once
 */
export const ApplyAllFiltersButton = ({
  onApplyAll,
  hasReportBeenRun = false,
  hasMadeFilterChanges = false,
  pendoIds,
}: {
  onApplyAll?: () => void;
  hasReportBeenRun?: boolean;
  hasMadeFilterChanges?: boolean;
  pendoIds?: FilterBarPendoIds;
}) => {
  const btnText = useMemo(() => I18n.t('apply_all_filters', { scope }), []);

  return (
    <div className="apply-filters-button-container" id={pendoIds?.applyAllFilters}>
      {hasMadeFilterChanges && (
        <>
          <ForgeBadge
            theme="secondary"
            data-testid="new-filters-applied-badge"
            id="new-filters-selected-badge"
          >
            <ForgeIcon name="info" slot="start" />
            <span>{I18n.t('filters_changed', { scope })}</span>
          </ForgeBadge>
          <ForgeTooltip anchor="new-filters-selected-badge" placement={'top'}>
            {I18n.t('filters_changed_tooltip', { scope, runReportButtonText: btnText })}
          </ForgeTooltip>
        </>
      )}

      <ForgeButton
        variant="raised"
        onClick={onApplyAll}
        data-testid="run-report-button"
        disabled={hasReportBeenRun && !hasMadeFilterChanges}
      >
        {btnText}
      </ForgeButton>
    </div>
  );
};
